import { render } from "./SensorDialog.vue?vue&type=template&id=59c06392&scoped=true"
import script from "./SensorDialog.vue?vue&type=script&lang=ts"
export * from "./SensorDialog.vue?vue&type=script&lang=ts"

import "./SensorDialog.vue?vue&type=style&index=0&id=59c06392&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-59c06392"

export default script